var _ellipse, _g, _g2, _g3, _g4, _path, _g5, _path2, _path3, _path4, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _circle, _g12, _g13, _g14, _g15, _g16, _g17, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 709,
    height: 349,
    viewBox: "0 0 709 349",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 354.5,
    cy: 309.5,
    rx: 354.5,
    ry: 39.5,
    fill: "url(#paint0_linear_2185_23143)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2185_23143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459 167.68C459 160.632 466.096 155.796 472.657 158.373L480.657 161.516C484.483 163.019 487 166.712 487 170.823V207.961C487 212.187 484.343 215.957 480.363 217.378L472.363 220.235C465.851 222.561 459 217.733 459 210.818V167.68Z",
    fill: "#418FDE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2185_23143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239 167.68C239 160.632 231.904 155.796 225.343 158.373L217.343 161.516C213.517 163.019 211 166.712 211 170.823V207.961C211 212.187 213.657 215.957 217.637 217.378L225.637 220.235C232.149 222.561 239 217.733 239 210.818V167.68Z",
    fill: "#418FDE"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_2185_23143)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 349,
    y1: 71.0078,
    x2: 349,
    y2: 37.0078,
    stroke: "#212121",
    strokeWidth: 8.00001
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_2185_23143)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 349,
    cy: 188.996,
    rx: 124,
    ry: 100,
    fill: "#195AB4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M233 163.004C233 138.703 252.699 119.004 277 119.004H421C445.301 119.004 465 138.703 465 163.004V163.004C465 187.304 445.301 207.004 421 207.004H277C252.7 207.004 233 187.304 233 163.004V163.004Z",
    fill: "#212121"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_di_2185_23143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277 123.004H421C443.091 123.004 461 140.913 461 163.004C461 185.095 443.092 203.004 421 203.004H277C254.909 203.004 237 185.095 237 163.004C237 140.913 254.909 123.004 277 123.004Z",
    stroke: "#418FDE",
    strokeWidth: 8.00001,
    shapeRendering: "crispEdges"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M313.297 169.516H318.031V173.055H313.297V180.977H308.938V173.055H293.398V170.5L308.68 146.852H313.297V169.516ZM298.32 169.516H308.938V152.781L308.422 153.719L298.32 169.516Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M363.344 166.422C363.344 171.5 362.477 175.273 360.742 177.742C359.008 180.211 356.297 181.445 352.609 181.445C348.969 181.445 346.273 180.242 344.523 177.836C342.773 175.414 341.867 171.805 341.805 167.008V161.219C341.805 156.203 342.672 152.477 344.406 150.039C346.141 147.602 348.859 146.383 352.563 146.383C356.234 146.383 358.938 147.563 360.672 149.922C362.406 152.266 363.297 155.891 363.344 160.797V166.422ZM359.008 160.492C359.008 156.82 358.492 154.148 357.461 152.477C356.43 150.789 354.797 149.945 352.563 149.945C350.344 149.945 348.727 150.781 347.711 152.453C346.695 154.125 346.172 156.695 346.141 160.164V167.102C346.141 170.789 346.672 173.516 347.734 175.281C348.813 177.031 350.438 177.906 352.609 177.906C354.75 177.906 356.336 177.078 357.367 175.422C358.414 173.766 358.961 171.156 359.008 167.594V160.492Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M407.203 169.516H411.938V173.055H407.203V180.977H402.844V173.055H387.305V170.5L402.586 146.852H407.203V169.516ZM392.227 169.516H402.844V152.781L402.328 153.719L392.227 169.516Z",
    fill: "white"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    styleHelpModal: "mix-blend-mode:hard-light",
    filter: "url(#filter5_f_2185_23143)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 352.123,
    cy: 162.038,
    rx: 71.1235,
    ry: 21.0375,
    fill: "#FF0000",
    fillOpacity: 0.3
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    styleHelpModal: "mix-blend-mode:hard-light",
    filter: "url(#filter6_f_2185_23143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.524 167.637V166.597H317.484H313.79V144.973V143.933H312.75H308.133H307.567L307.259 144.408L291.978 168.057L291.812 168.314V168.621V171.176V172.216H292.852H307.351V179.098V180.138H308.391H312.75H313.79V179.098V172.216H317.484H318.524V171.176V167.637ZM307.351 166.597H299.673L307.351 154.59V166.597ZM343.134 176.566L343.135 176.569C345.126 179.305 348.173 180.606 352.063 180.606C356.004 180.606 359.073 179.27 361.046 176.461C362.962 173.734 363.837 169.704 363.837 164.543L363.837 158.918L363.837 158.908C363.789 153.919 362.888 150.03 360.962 147.426C358.982 144.733 355.924 143.464 352.016 143.464C348.066 143.464 344.988 144.78 343.012 147.557C341.093 150.254 340.218 154.24 340.218 159.34V165.129H340.218L340.218 165.142C340.282 170.034 341.203 173.894 343.134 176.566ZM356.027 151.14L356.029 151.144C356.904 152.562 357.421 154.992 357.421 158.613V165.708C357.374 169.21 356.831 171.579 355.941 172.987L355.937 172.993C355.117 174.311 353.886 174.987 352.063 174.987C350.229 174.987 348.952 174.281 348.076 172.861C347.162 171.34 346.634 168.846 346.634 165.223V158.29C346.665 154.886 347.184 152.544 348.053 151.114C348.852 149.799 350.102 149.106 352.016 149.106C353.944 149.106 355.212 149.807 356.027 151.14ZM412.431 167.637V166.597H411.391H407.696V144.973V143.933H406.656H402.039H401.473L401.166 144.408L385.884 168.057L385.718 168.314V168.621V171.176V172.216H386.758H401.257V179.098V180.138H402.297H406.656H407.696V179.098V172.216H411.391H412.431V171.176V167.637ZM401.257 166.597H393.579L401.257 154.59V166.597Z",
    stroke: "#FF5C00",
    strokeWidth: 2.08002
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    styleHelpModal: "mix-blend-mode:hard-light",
    filter: "url(#filter7_f_2185_23143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.844 167.637V166.277H317.484H314.11V144.973V143.613H312.75H308.133H307.392L306.991 144.235L291.709 167.883L291.492 168.22V168.621V171.176V172.536H292.852H307.031V179.098V180.458H308.391H312.75H314.11V179.098V172.536H317.484H318.844V171.176V167.637ZM307.031 166.277H300.257L307.031 155.685V166.277ZM342.874 176.754L342.877 176.757C344.941 179.595 348.096 180.926 352.063 180.926C356.082 180.926 359.261 179.559 361.308 176.645C363.28 173.838 364.157 169.729 364.157 164.543L364.157 158.918L364.157 158.905C364.109 153.89 363.205 149.92 361.22 147.236C359.164 144.441 355.997 143.144 352.016 143.144C347.99 143.144 344.802 144.489 342.751 147.372C340.775 150.149 339.898 154.214 339.898 159.34V165.129V165.138L339.898 165.147C339.962 170.068 340.888 174.005 342.874 176.754ZM355.754 151.307L355.757 151.312C356.584 152.652 357.101 155.008 357.101 158.613V165.706C357.054 169.189 356.512 171.485 355.671 172.816L355.671 172.816L355.666 172.824C354.91 174.037 353.788 174.667 352.063 174.667C350.333 174.667 349.163 174.012 348.349 172.695C347.481 171.249 346.954 168.826 346.954 165.223V158.291C346.985 154.907 347.503 152.636 348.326 151.28C349.058 150.075 350.196 149.426 352.016 149.426C353.849 149.426 355.005 150.082 355.754 151.307ZM412.751 167.637V166.277H411.391H408.016V144.973V143.613H406.656H402.039H401.299L400.897 144.235L385.616 167.883L385.398 168.22V168.621V171.176V172.536H386.758H400.937V179.098V180.458H402.297H406.656H408.016V179.098V172.536H411.391H412.751V171.176V167.637ZM400.937 166.277H394.164L400.937 155.685V166.277Z",
    stroke: "#FF0000",
    strokeWidth: 2.72003
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    styleHelpModal: "mix-blend-mode:hard-light",
    filter: "url(#filter8_ddi_2185_23143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.524 167.637V166.597H317.484H313.79V144.973V143.933H312.75H308.133H307.567L307.259 144.408L291.978 168.057L291.812 168.314V168.621V171.176V172.216H292.852H307.351V179.098V180.138H308.391H312.75H313.79V179.098V172.216H317.484H318.524V171.176V167.637ZM307.351 166.597H299.673L307.351 154.59V166.597ZM343.134 176.566L343.135 176.569C345.126 179.305 348.173 180.606 352.063 180.606C356.004 180.606 359.073 179.27 361.046 176.461C362.962 173.734 363.837 169.704 363.837 164.543L363.837 158.918L363.837 158.908C363.789 153.919 362.888 150.03 360.962 147.426C358.982 144.733 355.924 143.464 352.016 143.464C348.066 143.464 344.988 144.78 343.012 147.557C341.093 150.254 340.218 154.24 340.218 159.34V165.129H340.218L340.218 165.142C340.282 170.034 341.203 173.894 343.134 176.566ZM356.027 151.14L356.029 151.144C356.904 152.562 357.421 154.992 357.421 158.613V165.708C357.374 169.21 356.831 171.579 355.941 172.987L355.937 172.993C355.117 174.311 353.886 174.987 352.063 174.987C350.229 174.987 348.952 174.281 348.076 172.861C347.162 171.34 346.634 168.846 346.634 165.223V158.29C346.665 154.886 347.184 152.544 348.053 151.114C348.852 149.799 350.102 149.106 352.016 149.106C353.944 149.106 355.212 149.807 356.027 151.14ZM412.431 167.637V166.597H411.391H407.696V144.973V143.933H406.656H402.039H401.473L401.166 144.408L385.884 168.057L385.718 168.314V168.621V171.176V172.216H386.758H401.257V179.098V180.138H402.297H406.656H407.696V179.098V172.216H411.391H412.431V171.176V167.637ZM401.257 166.597H393.579L401.257 154.59V166.597Z",
    stroke: "#FF0000",
    strokeOpacity: 0.2,
    strokeWidth: 2.08002
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_2185_23143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.124 167.637V166.997H317.484H313.39V144.973V144.333H312.75H308.133H307.784L307.595 144.625L292.314 168.274L292.212 168.432V168.621V171.176V171.816H292.852H307.751V179.098V179.738H308.391H312.75H313.39V179.098V171.816H317.484H318.124V171.176V167.637ZM307.751 166.997H298.942L307.751 153.222V166.997ZM343.458 176.332L343.459 176.333C345.357 178.943 348.269 180.206 352.063 180.206C355.906 180.206 358.838 178.909 360.719 176.231C362.565 173.603 363.437 169.672 363.437 164.543L363.437 158.918L363.437 158.912C363.39 153.954 362.493 150.167 360.64 147.663C358.755 145.099 355.833 143.864 352.016 143.864C348.161 143.864 345.221 145.142 343.338 147.789C341.49 150.386 340.618 154.272 340.618 159.34L340.618 165.129L340.618 165.137C340.681 169.993 341.597 173.756 343.458 176.332ZM356.368 150.931L356.369 150.934C357.304 152.45 357.821 154.973 357.821 158.613V165.71C357.774 169.236 357.23 171.698 356.279 173.201L356.277 173.205C355.376 174.652 354.008 175.387 352.063 175.387C350.099 175.387 348.688 174.616 347.734 173.07C346.763 171.455 346.234 168.871 346.234 165.223V158.288C346.265 154.859 346.786 152.43 347.711 150.907C348.593 149.454 349.985 148.706 352.016 148.706C354.062 148.706 355.47 149.462 356.368 150.931ZM412.031 167.637V166.997H411.391H407.296V144.973V144.333H406.656H402.039H401.691L401.502 144.625L386.22 168.274L386.118 168.432V168.621V171.176V171.816H386.758H401.657V179.098V179.738H402.297H406.656H407.296V179.098V171.816H411.391H412.031V171.176V167.637ZM401.657 166.997H392.849L401.657 153.222V166.997Z",
    stroke: "#FF9983",
    strokeWidth: 1.28001
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_2185_23143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.383 147.853C358.573 145.391 355.76 144.184 352.016 144.184C348.237 144.184 345.407 145.432 343.599 147.975C341.807 150.492 340.938 154.298 340.938 159.34L340.938 165.129L340.938 165.133C341.001 169.959 341.912 173.646 343.717 176.144L343.718 176.145C345.542 178.653 348.345 179.886 352.063 179.886C355.828 179.886 358.649 178.621 360.457 176.047C362.247 173.499 363.117 169.646 363.117 164.543L363.117 158.918L363.117 158.915C363.07 153.983 362.176 150.277 360.383 147.853ZM360.383 147.853C360.383 147.853 360.383 147.853 360.383 147.853L360.125 148.043M360.383 147.853C360.382 147.853 360.382 147.853 360.382 147.853L360.125 148.043M360.125 148.043C361.859 150.387 362.75 154.012 362.797 158.918V164.543C362.797 169.621 361.93 173.395 360.195 175.863C358.461 178.332 355.75 179.566 352.063 179.566C348.422 179.566 345.727 178.363 343.977 175.957C342.227 173.535 341.32 169.926 341.258 165.129V159.34C341.258 154.324 342.125 150.598 343.859 148.16C345.594 145.723 348.313 144.504 352.016 144.504C355.688 144.504 358.391 145.684 360.125 148.043ZM317.804 167.637V167.317H317.484H313.07V144.973V144.653H312.75H308.133H307.959L307.864 144.799L292.583 168.447L292.532 168.527V168.621V171.176V171.496H292.852H308.071V179.098V179.418H308.391H312.75H313.07V179.098V171.496H317.484H317.804V171.176V167.637ZM308.071 167.317H298.358L308.071 152.128V167.317ZM356.641 150.765L356.642 150.766C357.625 152.36 358.141 154.957 358.141 158.613V165.712C358.094 169.256 357.548 171.792 356.55 173.372L356.549 173.374C355.582 174.926 354.105 175.707 352.063 175.707C349.995 175.707 348.477 174.884 347.461 173.236C346.444 171.546 345.914 168.891 345.914 165.223V158.287C345.945 154.838 346.467 152.338 347.438 150.74C348.386 149.178 349.891 148.386 352.016 148.386C354.156 148.386 355.676 149.186 356.641 150.765ZM411.711 167.637V167.317H411.391H406.976V144.973V144.653H406.656H402.039H401.865L401.77 144.799L386.489 168.447L386.438 168.527V168.621V171.176V171.496H386.758H401.977V179.098V179.418H402.297H406.656H406.976V179.098V171.496H411.391H411.711V171.176V167.637ZM401.977 167.317H392.264L401.977 152.128V167.317Z",
    stroke: "white",
    strokeWidth: 0.640007
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_bii_2185_23143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233 163.004C233 138.703 252.699 119.004 277 119.004H421C445.301 119.004 465 138.703 465 163.004V163.004C465 187.304 445.301 207.004 421 207.004H277C252.7 207.004 233 187.304 233 163.004V163.004Z",
    fill: "#212121",
    fillOpacity: 0.01
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_i_2185_23143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321 83.0078C321 76.3804 326.373 71.0078 333 71.0078H365C371.627 71.0078 377 76.3804 377 83.0078V91.5914C377 96.1367 374.432 100.292 370.367 102.325L361.534 106.741C359.868 107.574 358.03 108.008 356.167 108.008H341.405C339.496 108.008 337.614 107.552 335.917 106.679L327.512 102.357C323.513 100.3 321 96.1815 321 91.6853V83.0078Z",
    fill: "#418FDE"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 28.9922,
    r: 20,
    fill: "#E00000"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    styleHelpModal: "mix-blend-mode:hard-light",
    filter: "url(#filter13_f_2185_23143)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 29,
    r: 24,
    fill: "white",
    fillOpacity: 0.2
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    styleHelpModal: "mix-blend-mode:hard-light",
    filter: "url(#filter14_f_2185_23143)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 29,
    r: 19.4583,
    stroke: "white",
    strokeWidth: 1.08333
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    styleHelpModal: "mix-blend-mode:hard-light",
    filter: "url(#filter15_f_2185_23143)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 29,
    r: 19.2917,
    stroke: "white",
    strokeWidth: 1.41667
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    styleHelpModal: "mix-blend-mode:hard-light",
    filter: "url(#filter16_ddi_2185_23143)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 29,
    r: 19.4583,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.08333
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_f_2185_23143)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 29,
    r: 19.6667,
    stroke: "#E00000",
    strokeWidth: 0.666667
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_f_2185_23143)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 349,
    cy: 29,
    r: 19.8333,
    stroke: "white",
    strokeWidth: 0.333334
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M387 248.992C387 254.515 369.987 245.992 349 245.992C328.013 245.992 311 254.515 311 248.992C311 243.469 328.013 238.992 349 238.992C369.987 238.992 387 243.469 387 248.992Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2185_23143",
    x: 459,
    y: 157.672,
    width: 28,
    height: 71.1563,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.00001
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2185_23143"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2185_23143",
    x: 211,
    y: 157.672,
    width: 36,
    height: 71.1563,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.00001,
    dy: 8.00001
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2185_23143"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_2185_23143",
    x: 345,
    y: 37.0078,
    width: 10,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2185_23143"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_2185_23143",
    x: 225,
    y: 88.9961,
    width: 256,
    height: 208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 16,
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2185_23143"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_di_2185_23143",
    x: 225,
    y: 119.004,
    width: 248,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.00001
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2185_23143"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2185_23143",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.00001
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2185_23143"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_2185_23143",
    x: 266.6,
    y: 126.6,
    width: 171.046,
    height: 70.8745,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.20008,
    result: "effect1_foregroundBlur_2185_23143"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_2185_23143",
    x: 276.373,
    y: 128.026,
    width: 151.496,
    height: 68.0191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.20008,
    result: "effect1_foregroundBlur_2185_23143"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_2185_23143",
    x: 285.333,
    y: 136.985,
    width: 133.577,
    height: 50.1001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.40003,
    result: "effect1_foregroundBlur_2185_23143"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_ddi_2185_23143",
    x: 284.533,
    y: 140.986,
    width: 135.175,
    height: 51.6989,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.08002
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.800008
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.15 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2185_23143"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.80005
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.12003
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8 0 0 0 0 0.19 0 0 0 0 0.19 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "color-dodge",
    in2: "effect1_dropShadow_2185_23143",
    result: "effect2_dropShadow_2185_23143"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2185_23143",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.208002,
    dy: 0.416004
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.104001
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_2185_23143"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_2185_23143",
    x: 291.25,
    y: 142.903,
    width: 121.742,
    height: 38.265,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.160002,
    result: "effect1_foregroundBlur_2185_23143"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_2185_23143",
    x: 291.998,
    y: 143.65,
    width: 120.247,
    height: 36.7704,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.106668,
    result: "effect1_foregroundBlur_2185_23143"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_bii_2185_23143",
    x: 222.333,
    y: 108.337,
    width: 253.333,
    height: 109.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 0.533334
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2185_23143"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2185_23143",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10.6667,
    dy: 10.6667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.33334
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2185_23143"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10.6667,
    dy: -10.6667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.33334
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0983529 0 0 0 0 0.0983529 0 0 0 0 0.0983529 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_2185_23143",
    result: "effect3_innerShadow_2185_23143"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_i_2185_23143",
    x: 321,
    y: 71.0078,
    width: 64,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.00001,
    dy: 8.00001
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2185_23143"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_2185_23143",
    x: 320,
    y: -0.0000038147,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2185_23143"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_2185_23143",
    x: 324,
    y: 4,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2185_23143"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_2185_23143",
    x: 327.333,
    y: 7.33333,
    width: 43.3333,
    height: 43.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.833334,
    result: "effect1_foregroundBlur_2185_23143"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_ddi_2185_23143",
    x: 326.833,
    y: 8.5,
    width: 44.3333,
    height: 44.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.08333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.416667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.878431 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2185_23143"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.66667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.08333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.878431 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "color-dodge",
    in2: "effect1_dropShadow_2185_23143",
    result: "effect2_dropShadow_2185_23143"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2185_23143",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.108333,
    dy: 0.216667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0541667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.878431 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_2185_23143"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_2185_23143",
    x: 328.833,
    y: 8.83333,
    width: 40.3333,
    height: 40.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0833334,
    result: "effect1_foregroundBlur_2185_23143"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_f_2185_23143",
    x: 328.889,
    y: 8.88889,
    width: 40.2222,
    height: 40.2222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0555556,
    result: "effect1_foregroundBlur_2185_23143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2185_23143",
    x1: 354.5,
    y1: 270,
    x2: 354.5,
    y2: 349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2C4C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.7565d2b59de1fc14b5d709ff57b4e45e.svg";
export { ForwardRef as ReactComponent };